import React, { useState, useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import SEO, { SITE_URL } from '../components/SEO'
import ShopChat from '../components/ShopChat'
import LocationBar from '../components/ShopChat/locationbar'
import { ShopPage, Hero, ShopTitle, ShopSubtitle, Section, Grid, BusinessCard, Crumbs } from '../components/ShopChat/shopcommon'
import { fetchWrapper } from '../utils/apiHandlers'
import { useShopLocation } from '../utils/shopLocation'

const ShopCategory: React.FC = () => {
  const { category } = useParams<{ category: string }>()
  const { location, ready } = useShopLocation()
  const [businesses, setbusinesses] = useState<any[] | null>(null)

  useEffect(() => {
    if (!ready) return
    setbusinesses(null)
    const q = location ? `&lat=${location.lat}&lon=${location.lon}` : ''
    fetchWrapper.get(`/api/directory/list?category=${encodeURIComponent(category)}${q}`)
      .then((r: any) => setbusinesses(r.businesses || []))
      .catch(() => setbusinesses([]))
  }, [category, ready, location])

  const label = businesses && businesses[0] ? businesses[0].categorylabel : category
  const cities = businesses ? Array.from(new Set(businesses.map((b) => b.city).filter(Boolean))) : []
  const city = cities.length === 1 ? (cities[0] as string) : ''
  const heading = `${label}${city ? ` in ${city}` : ''}`

  return (
    <ShopPage>
      <SEO
        title={`${heading} - Places | MiAmigo.AI`}
        description={`Browse local ${String(label).toLowerCase()}${city ? ` in ${city}` : ''} and ask Amigo which one fits.`}
        path={`/places/${category}`}
        jsonLd={businesses && businesses.length ? {
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": label,
          "itemListElement": businesses.map((b, i) => ({ "@type": "ListItem", "position": i + 1, "url": `${SITE_URL}/places/${b.category}/${b.slug}`, "name": b.name })),
        } : undefined}
      />
      <Hero>
        <Crumbs style={{ color: 'rgba(255,255,255,0.8)', textAlign: 'center', paddingTop: 0 }}>
          <Link to="/ask" style={{ color: '#cfe4ff' }}>Ask Amigo</Link> / {label}
        </Crumbs>
        <ShopTitle>{heading}</ShopTitle>
        <ShopSubtitle>Not sure which one? Ask the assistant.</ShopSubtitle>
        <LocationBar onDark />
      </Hero>
      <Section style={{ maxWidth: 680 }}>
        <ShopChat category={category} placeholder={`Ask about ${String(label).toLowerCase()}...`} greeting={`Hi! Tell me what you need and I'll find the right place among these ${String(label).toLowerCase()}.`} />
      </Section>
      <Section>
        {businesses === null ? null : businesses.length === 0 ? (
          <ShopSubtitle>No businesses listed here yet. <Link to="/ask">Ask Amigo</Link> or <Link to="/places/restaurants">browse another category</Link>.</ShopSubtitle>
        ) : (
          <Grid>{businesses.map((b) => <BusinessCard key={b.slug} b={b} />)}</Grid>
        )}
      </Section>
    </ShopPage>
  )
}

export default ShopCategory
